export const PERMISSION_ENDPOINT = `settings/permission`;
